import React from 'react';
import { ActiveSubmenuContextProvider } from '../../ActiveSubmenu/ActiveSubmenuProvider';
import { SideFlyoutMenu } from './SideFlyoutMenu';
import { NavThemeProvider } from '../NavThemeProvider';
import { useS4AMastheadContext } from '../../S4AMastheadProvider';
import { useUserState } from '../hooks/useUserState';
export var NavBarCompact = function (_a) {
    var forcedUserState = _a.forcedUserState, colors = _a.colors, className = _a.className;
    var userState = useUserState(forcedUserState);
    var mastheadData = useS4AMastheadContext().mastheadData;
    if (userState === 'loading' || !mastheadData) {
        return React.createElement("div", null);
    }
    return (React.createElement(NavThemeProvider, { colors: colors },
        React.createElement(ActiveSubmenuContextProvider, null,
            React.createElement("div", { className: className },
                React.createElement(SideFlyoutMenu, { forcedUserState: forcedUserState })))));
};
